
import { defineComponent, PropType } from "vue";
// components
import DemandTemplateTableRow from "./DemandTemplateTableRow.vue";
import TableBase from "@/components/table/TableBase.vue";
import TableHeaderItem from "@/components/table/TableHeaderItem.vue";
// other
import { DemandTemplate } from "@/graphql/types";

export default defineComponent({
  name: "DemandTemplateTable",
  components: {
    DemandTemplateTableRow,
    TableBase,
    TableHeaderItem
  },
  props: {
    workAreaId: {
      type: String,
      requried: true
    },
    selectable: { type: Boolean, default: false },
    demandTemplates: { type: Object as PropType<DemandTemplate[]>, required: true },
    selectedIdList: {
      required: false,
      default: () => [] // error if instead "type: Array"
    }
  },
  emits: ["selected"],
  setup(props, context) {
    // pass through event
    const onSelected = (demandTemplateId: string) => {
      context.emit("selected", demandTemplateId);
    };

    return { onSelected };
  }
});
